<template>
  <div class="container">
    <div v-if="inv && inv.paid"> 

      <div class="columns border-bottom-lg">
        <div class="column col-6">
          <img v-if="brand === 'pl'" src="../../assets/pocketlegal_logo.png" alt="PocketLegal" class="invoiceLogo"/>
          <img v-if="brand === 'ie'" src="../../assets/immiexperts.png" alt="Immigration Experts" class="invoiceLogo"/>
        </div>
        <div class="column col-6 text-right">
          <h1>Receipt</h1>
        </div>
        <div v-if="brand === 'pl'" class="column col-6">
          PocketLegal Pty Ltd<br />
          162 Redfern Street<br />
          Redfern 2016, NSW<br />
          <a href="mailto:accounts@pocketlegal.com.au">accounts@pocketlegal.com.au</a><br />
          Phone: (02) 8385 1451<br />
          ABN: 12 613 908 124<br />
          ACN: 613 908 124
        </div>
        <div v-if="brand === 'ie'" class="column col-6">
          Immigration Experts Pty Ltd<br />
          162 Redfern Street<br />
          Redfern 2016, NSW<br />
          <a href="mailto:info@immiexperts.com.au">info@immiexperts.com.au</a><br />
          Phone: (02) 9279 1289<br />
          ABN: 12 613 908 124<br />
          ACN: 613 908 124
        </div>
      </div>
      <div class="columns border-bottom-lg">
        <div class="column col-4">Reference</div>
        <div class="column col-8">{{inv.ref}}</div>
        <div class="column col-4">Client</div>
        <div class="column col-8">{{inv.business ? inv.business : inv.firstname + ' ' + inv.lastname}}</div>         
        <div class="column col-4" v-if="inv.business">Attn</div>
        <div class="column col-8" v-if="inv.business">{{inv.firstname}} {{inv.lastname}}</div>
        <div class="column col-4">Invoice date</div>
        <div class="column col-8">{{date(inv.date)}}</div>
        <div class="column col-4">Invoice status</div>
        <div class="column col-8">
          <span class="label label-success">Paid {{paymentDate(inv)}}</span>
        </div>
      </div>

      <div class="border-bottom-lg">
        <div class="columns">
          <div class="column col-12">
            <h2>Description</h2>
            <h4>{{inv.matter_desc}}</h4>
          </div>
        </div>

        <div class="columns" v-for="item in inv.items">
          <div class="column col-4">{{item.description}}</div>
          <div class="column col-8">${{c2d(item.cost)}}</div>
        </div>

        <div class="columns" v-if="inv.gst">
          <div class="column col-4">GST (10%)</div>
          <div class="column col-8">${{c2d(inv.gst)}}</div>
        </div>

        <div class="columns" v-if="inv.surcharge">
          <div class="column col-4">Surcharge (1.4%)</div>
          <div class="column col-8">${{c2d(inv.surcharge)}}</div>
        </div>

        <div class="columns"> 
          <div class="column col-4">Total</div>
          <div class="column col-8">${{c2d(inv.total)}}</div>
        </div>

      </div>

      <div class="columns border-bottom-sm invoicePrint">
        <div class="column col-12">
          <button class="btn bg-gray" @click="print">Print this page</button>
        </div>
      </div>


      <!-- PLAN -->
      <div v-if="inv.plan" class="paymentPlanTable">
        <table class="table">
          <thead>
            <tr>
              <th colspan="3"><h4>Your payment plan</h4></th>
            </tr>
            <tr>
              <th>Monthly payment amount: ${{c2d(inv.monthly)}}</h4></th>
              <th>Remaining: ${{c2d(inv.outstanding)}}</th>
              <th></th>
            </tr>
            <tr>
              <th>Date</th>
              <th>Monthly amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in payments(inv)">
              <td v-if="inv.last_payment">{{payment.date}}</td>
              <td v-else>Upcoming</td>
              <td>${{c2d(payment.amount)}}</td>
              <td>
                <span v-if="payment.paid" class="label label-rounded label-success">Paid</span>
                <span v-else class="label label-rounded label-warning">Scheduled</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END PLAN -->
      
    </div>
    <!-- END INVOICE CONTENT -->

  </div>
</template>

<script>
import utils from '@/components/utils'
import axios from 'axios'

export default {
  name: 'receipt',
  mixins: [utils],
  data () {
    return {
      inv: null,
      showPay: false
    }
  },
  created () {
    this.getInvoice()
  },
  computed: {
    brand () {
      return this.inv.brand || 'pl'
    }
  },
  methods: {
    getInvoice () {
      // Extract the invoice id from the address
      let id = /\w{24}/.exec(window.location.toString())
      if (!id) return

      axios.get('/api/invoices/one/' + id[0]).then(res => {
        if (res.status === 200) {
          this.inv = res.data
        }
      }).catch(e => { console.log(e.response.data) })
    },
    date (d) {
      return new Date(d).toLocaleDateString('en-AU')
    },
    paymentDate (inv) {
      if (!inv.payments || inv.payments.length < 1) return ''
      return this.date(inv.payments[inv.payments.length - 1].time)
    },
    c2d (c) {
      return (c / 100).toFixed(2)
    },
    print () {
      window.print()
    }
  }
}
</script>

<style scoped>
a {
  color:#136efb!important
}
.container {
  width: 90%;
  max-width: 960px;
  margin-top: 1.5em;
  margin-bottom: 1.5em
}
.invoice-title {
  cursor: pointer;
}
.tile.ClientPayment {
  padding: 1em 0;
  border-bottom: 1px solid #e7e9ed
}
.table tr:last-child {
  border-bottom: none;
}
.table tr:last-child td {
  border-bottom: none;
}
.paymentPlanTable {
  background: #3fa9f512;
  border: 1px solid #3fa9f5;
  border-radius: 2px;
  margin: 2em 0;
  padding: 2em;
}
.paymentPlanTable th,
.paymentPlanTable tr,
.paymentPlanTable td {
  border-bottom: 1px solid #3fa9f5;
  border: none;
}
.invoiceLogo {
  width:25%;
  display:block;
  padding: 0 0 1em 0;
  min-width: 165px
}
.border-bottom-lg {
  border-bottom: 3px solid;
  padding: 2em 0
}
.border-bottom-sm {
  border-bottom: 1px solid;
  padding: 2em 0
}
.btn {
  border-color: #136efb;
  color: #136efb
}
.btn:hover {
  border-color: #136efb;
  color: #136efb;
}
.btn:active {
  border-color: #136efb;
  background:  #136efb;
  color: #fff
}
@media print {
  .invoicePrint {
    display: none
  }
  .label.label-warning {
    background: #ccc;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// receipt.vue?577d9e08